/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : <<author>>
 * Created Date: 2024-06-14 13:55:26
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) <<year>> <<company>>. All rights reserved.
 */


/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2022-05-23 13:56:12
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */


import { RouterConfig } from 'src/router/types';
import {lazy} from 'react';

const sinamedAndFacthorRouterCOnfig: RouterConfig[] = [
    {
        key: 'Sinamed & Facthor',
        title: 'menuTitleSinamedAndFacthor',
        icon: 'SinamedMenuSvg',
        subs: [
            {
                key: 'Sinamed Interface Config',
                title: 'menuKeySinamedPushConfig',
                route: '/home/sinamedAndFacthor/sinamedPushConfig',
                component: lazy(() => import('src/pages/configuration/sinamedPushConfig')),
            },
            {
                key: 'Sinamed 34 Interface Log',
                route: '/home/sinamedAndFacthor/pushDataLog',
                title: 'menuTitlePushDataLog',
                component: lazy(() => import('src/pages/logQuery/pushDataLog')),
            },
            {
                key: 'Sinamed 48 Interface Log',
                route: '/home/sinamedAndFacthor/SINAMEDPushDataLog',
                title: 'menuTitleSINAMEDPushDataLog',
                component: lazy(() => import('src/pages/logQuery/sinamedPushLog')),
            },
            {
                key: 'Facthor HM Interface Log',
                route: '/home/sinamedAndFacthor/FACTHORLog',
                title: 'menuTitleFACTHORLog',
                component: lazy(() => import('src/pages/logQuery/facthorLog/index')),
            },
            {
                key: 'Facthor Interface Log',
                route: '/home/sinamedAndFacthor/FACTHORVerificationLog',
                title: 'tabsTitleVerificationLog',
                component: lazy(() => import('src/pages/logQuery/facthorLog/verificationLog')),
            },
        ],
    },
];

export default sinamedAndFacthorRouterCOnfig;
